import React from 'react';
export const DisplayUser = ({
  user
}) => {
  if (!user) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-gray-500"
    }, "\u65E0");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "text-xs"
  }, /*#__PURE__*/React.createElement("div", null, "\u7528\u6237 ID: ", /*#__PURE__*/React.createElement("b", null, user.user_id)), /*#__PURE__*/React.createElement("div", null, "\u624B\u673A\u53F7: ", /*#__PURE__*/React.createElement("b", null, user.mobile)), /*#__PURE__*/React.createElement("div", null, "\u59D3\u540D: ", /*#__PURE__*/React.createElement("b", null, user.real_name)));
};